document.querySelectorAll('.btn').forEach((btn) => {
  const text = btn.querySelector('.btn-text');

  // Some .btn elements don't contain .btn-text
  if (!text) return;

  btn.style.setProperty('--text-width', text.offsetWidth + 'px');
});

// magnet effect

const magnets = document.querySelectorAll('.bb-excellence');
const strength = 50;

function moveMagnet(event, magnet) {
  const rect = magnet.getBoundingClientRect();

  // Guard in case element is missing sizing info (rare, but safe)
  const w = magnet.offsetWidth || 1;
  const h = magnet.offsetHeight || 1;

  const x = ((event.clientX - rect.left) / w - 0.5) * strength;
  const y = ((event.clientY - rect.top) / h - 0.5) * strength;

  magnet.style.transform = `translate(${x}px, ${y}px)`;
}

function resetMagnet(magnet) {
  magnet.style.transform = `translate(0px, 0px)`;
}

magnets.forEach((magnet) => {
  magnet.addEventListener('mousemove', (e) => moveMagnet(e, magnet));
  magnet.addEventListener('mouseleave', () => resetMagnet(magnet));
});